<template>
  <div class="floating-contact">
    <v-btn
      v-for="(item, index) in contactItems"
      v-show="item.name !== 'top' || showTopBtn"
      :key="index"
      :href="item.href || undefined"
      :rel="item.href ? 'nofollow noopener noreferrer' : undefined"
      :target="item.target || undefined"
      fab
      small
      class="contact-btn"
      :style="{ bottom: `${20 + index * 55}px` }"
      :color="item.color"
      elevation="6"
      @click="handleClick(item, $event)"
    >
      <v-img
        v-if="item.imageUrl"
        :src="item.imageUrl"
        :alt="item.name || 'contact icon'"
        max-width="22"
        max-height="22"
      />
      <v-icon
        v-else
        :color="item.iconColor || 'white'"
      >
        {{ resolveIcon(item.icon) }}
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
  import {
    mdiWhatsapp,
    mdiSend,
    mdiChevronUp,
    mdiPhone,
    mdiEmail,
    mdiEmailOutline,
    mdiChat,
    mdiMessageText,
    mdiWeb,
    mdiFacebook,
    mdiInstagram,
    mdiTwitter,
    mdiLinkedin,
    mdiWechat,
    mdiSkype,
    mdiHelpCircleOutline,
  } from '@mdi/js'

  // SVG path lookup for instant rendering (no font download needed)
  const MDI_SVG_MAP = {
    'mdi-whatsapp': mdiWhatsapp,
    'mdi-telegram': mdiSend,
    'mdi-send': mdiSend,
    'mdi-chevron-up': mdiChevronUp,
    'mdi-phone': mdiPhone,
    'mdi-email': mdiEmail,
    'mdi-email-outline': mdiEmailOutline,
    'mdi-chat': mdiChat,
    'mdi-message-text': mdiMessageText,
    'mdi-web': mdiWeb,
    'mdi-facebook': mdiFacebook,
    'mdi-instagram': mdiInstagram,
    'mdi-twitter': mdiTwitter,
    'mdi-linkedin': mdiLinkedin,
    'mdi-wechat': mdiWechat,
    'mdi-skype': mdiSkype,
    'mdi-help-circle-outline': mdiHelpCircleOutline,
  }

  export default {
    name: 'FloatingContact',

    data: () => ({
      showTopBtn: false,
      contactItems: [
        {
          name: 'top',
          show: true,
          href: null,
          target: null,
          icon: 'mdi-chevron-up',
          color: 'primary',
          action: null,
          isMdi: true,
          imageUrl: '',
        },
      ],
    }),

    watch: {
      '$i18n.locale'() {
        this.loadContactItems()
      },
    },

    mounted() {
      this.loadContactItems()
      window.addEventListener('scroll', this.onScroll)
    },

    beforeDestroy() {
      window.removeEventListener('scroll', this.onScroll)
    },

    methods: {
      onScroll() {
        this.showTopBtn = window.scrollY > 300
      },
      resolveIcon(iconName) {
        return MDI_SVG_MAP[iconName] || iconName
      },
      async loadContactItems() {
        const fallbackItems = [
          {
            name: 'top',
            show: true,
            href: null,
            target: null,
            icon: 'mdi-chevron-up',
            color: 'primary',
            action: null,
            isMdi: true,
            imageUrl: '',
          },
        ]

        try {
          const blocks = await this.$axios({
            method: 'get',
            url: '/public/homepage',
            params: { lang: this.$i18n.locale },
          })

          const contactBlock = (blocks || []).find(item => item?.blockKey === 'contact_us' && item?.enabled !== false)

          const parseItems = (module) => {
            if (!module || !module.content) return []
            try {
              const parsed = JSON.parse(module.content)
              if (Array.isArray(parsed?.floating)) return parsed.floating
              if (Array.isArray(parsed?.items)) return parsed.items
            } catch {
            }
            return []
          }

          const sourceItems = parseItems(contactBlock)

          if (!sourceItems.length) {
            this.contactItems = fallbackItems
            return
          }

          const normalizedItems = sourceItems
            .filter(item => item && item.show !== false)
            .sort((a, b) => Number(a?.sort || 0) - Number(b?.sort || 0))
            .map(item => ({
              name: item.name || '',
              show: item.show !== false,
              href: item.href || null,
              target: item.target || null,
              icon: item.icon || 'mdi-help-circle-outline',
              color: item.color || 'primary',
              action: null,
              isMdi: item.isMdi !== false,
              imageUrl: item.imageUrl || '',
            }))

          this.contactItems = normalizedItems.length ? normalizedItems : fallbackItems
        } catch (error) {
          this.contactItems = fallbackItems
        }
      },
      handleClick(item, event) {
        // 如果按钮没有 href（比如 top 按钮），阻止默认行为
        if (!item.href) {
          event.preventDefault()
        }

        // 如果有自定义 action，执行它
        if (item.action) {
          item.action()
        } else if (item.name === 'top') {
          // 专门处理 top 按钮
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })
        }
      },
    },
  }
</script>

<style lang="sass" scoped>
.floating-contact
  position: fixed
  right: 20px
  bottom: 20px
  z-index: 1000

.contact-btn
  position: fixed !important
  right: 20px
  transition: all 0.3s ease
  margin-bottom: 8px

  &:hover
    transform: scale(1.1)
    box-shadow: 0 8px 16px rgba(0,0,0,0.3) !important
</style>
